import { Col, Row } from 'reactstrap';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ComponentCard from '../../common/components/cards/ComponentCard';
import Chart from './charts/Chart';
import { getHorizontalBarChartOptions } from './charts/horizontalBarChartOptions';
import { getTimeChartOptions } from './charts/timeChartOptions';

function PurchaseOverviewSection() {
  const purchaseStatistics = useSelector((state) => state.dashboard.get('purchaseStatistics'));
  const [soldMakes, setSoldMakes] = useState({ labels: [], series: [] });
  const [listingsAndPurchases, setListingsAndPurchases] = useState({ series: [] });

  useEffect(() => {
    mapSoldMakesData();
    mapListingsAndPurchasesData();
  }, [purchaseStatistics]);

  const mapSoldMakesData = () => {
    if (!purchaseStatistics) return;

    const soldMakes = purchaseStatistics?.soldMakes ?? [];
    const labels = soldMakes.map((it) => it.make);
    const counts = soldMakes.map((it) => it.quantity);

    setSoldMakes({
      labels,
      series: [
        {
          name: 'Quantity',
          data: counts,
        },
      ],
    });
  };

  const mapListingsAndPurchasesData = () => {
    if (!purchaseStatistics) return;
    const { listingsTime, purchasesTime } = purchaseStatistics;

    const listingsSeries = listingsTime.map((it) => ({
      x: it.time,
      y: it.listings,
    }));

    const purchasesSeries = purchasesTime.map((it) => ({
      x: it.time,
      y: it.purchases,
    }));

    setListingsAndPurchases({
      series: [
        { name: 'Listings', data: listingsSeries },
        { name: 'Purchases', data: purchasesSeries },
      ],
    });
  };

  return (
    <Row>
      <Col xs={12} md={12} lg={12} xl={6}>
        <ComponentCard title="Top 5 Brans Sold" isCollapsible>
          <Chart
            getOptions={getHorizontalBarChartOptions}
            props={{
              series: soldMakes.series,
              labels: soldMakes.labels,
              color: '#1c84c6d9',
            }}
            type="bar"
            height={225}
          />
        </ComponentCard>
      </Col>
      <Col xs={12} md={12} lg={12} xl={6}>
        <ComponentCard title="Key Times: Purchases & Listings" isCollapsible>
          <Chart
            getOptions={getTimeChartOptions}
            props={{
              series: listingsAndPurchases.series,
              colors: ['#7b70ef', '#f8ac59'],
            }}
            type="area"
            height={225}
          />
        </ComponentCard>
      </Col>
    </Row>
  );
}

export default PurchaseOverviewSection;
